import { axiosClient } from '../../../../library/Service/axiosClient';
import PageConfigService from '../../../../services/page-config.service';
import { REPORT_CONFIG } from './report-config';
import PageConfigQRCodeCheckinsWithoutProfiles from './PageConfigQRCodeCheckinsWithoutProfiles.json';


class InternalAdminQRReportService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};
        const searchCriteria = this.getDefaultSearchCriteria(params.pageName);
        
        return Promise.all([this.getPageConfig(params.pageName), this.search(searchCriteria, params.pageName)]).then((values) => {
            let formconfig = values[0];
            state.formConfig = formconfig;
            state.data = {
                alumniList: values[1].data ?? [],
                searchCriteria,
            };
            state.routeInfo = params;
            state.internal = { gridState: {} };
            return Promise.resolve(state);
        });
    }

    static getPageConfig(pageName:string) {
        if(pageName==='internal-admin-qr-code-checkins-without-profiles'){
            return Promise.resolve(PageConfigQRCodeCheckinsWithoutProfiles);
        }else{
            const res = PageConfigService.get(pageName);
            return res.then((data :any) => {
                return { data };
            });
        }
    }

    static getDefaultSearchCriteria(pageName: string = ''): any {
        return {
            schoolGroupId: null,
            schoolId: null,
            programName: [],
            passoutYear: []
        };
    }

    static search(searchCriteria: any, pageName: string) {
         const config = REPORT_CONFIG[pageName];
         const criteriaCopy = { ...searchCriteria };
         const criteria = this.sanitizeCriteria(criteriaCopy, pageName);
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/${config.SEARCH_API}`, criteria);
    }
    
    static searchCount(searchCriteria: any, pageName: string) {
        let COUNT_URL='search/qr-alumni-count';
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/${COUNT_URL}`, searchCriteria);
    }

    static sanitizeCriteria(searchCriteria: any, pageName: any) {
        const criteria = { ...searchCriteria };
        for (const [key, value] of Object.entries(searchCriteria)) {
            criteria[key] = Array.isArray(value) && typeof value[0] === 'object' ? value.map((obj) => Object.values(obj)[0]) : value;
        }

        return criteria;
    }
}

export default InternalAdminQRReportService;
